(() => {
 'use strict';
 const key='ca-size-chart-unit-v1';
 let unit='cm';
 try { if(localStorage.getItem(key)==='in')unit='in'; } catch {}
 function render(chart){
  chart.querySelectorAll('[data-cm]').forEach(cell=>{
   const cm=Number(cell.dataset.cm);
   if(Number.isFinite(cm))cell.textContent=unit==='in'?(cm/2.54).toFixed(2):cm.toFixed(1);
  });
  chart.querySelectorAll('[data-size-unit-label]').forEach(label=>{label.textContent=unit;});
  chart.querySelectorAll('[data-size-unit]').forEach(button=>{button.setAttribute('aria-pressed',String(button.dataset.sizeUnit===unit));});
  chart.querySelectorAll('[data-size-unit-controls]').forEach(controls=>{controls.hidden=false;});
 }
 function init(root=document){
  if(root.matches?.('[data-size-chart]'))render(root);
  root.querySelectorAll('[data-size-chart]').forEach(render);
 }
 document.addEventListener('click',event=>{
  const button=event.target.closest('[data-size-unit]');
  if(!button?.closest('[data-size-chart]')||!['cm','in'].includes(button.dataset.sizeUnit))return;
  unit=button.dataset.sizeUnit;
  try { localStorage.setItem(key,unit); } catch {}
  init();
 });
 document.addEventListener('shopify:section:load',event=>init(event.target));
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(),{once:true});
 else init();
 window.CASizeCharts={init};
})();
